import {useEffect, useState} from 'react'

type Theme = 'light' | 'dark'
const THEME_KEY = 'theme'

const getOsSetting = (): Theme => (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')

// 훅을 쓸 때 import는 hooks/DarkModeContext에서 해주세요!
export function useDarkMode() {
    const [theme, setTheme] = useState<Theme>('light')
    useEffect(() => {
        // 초기값 세팅
        const saved = localStorage.getItem(THEME_KEY) as Theme | null
        setTheme(saved ?? getOsSetting())
    }, [])

    // DOM 반영 + 저장
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme)
        document.documentElement.style.colorScheme = theme

        // 애플 PWA 대응
        const applePwaMetaTag = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
        applePwaMetaTag?.setAttribute('content', theme === 'dark' ? 'black-translucent' : 'default');
        const themeColorMetaTag = document.querySelector('meta[name="theme-color"]');
        themeColorMetaTag?.setAttribute('content', theme === 'dark' ? '#181818' : '#ffffff');

        localStorage.setItem(THEME_KEY, theme)
    }, [theme])

    // 저장값이 없을 때만 OS 변경 따라가기
    useEffect(() => {
        const saved = localStorage.getItem(THEME_KEY)
        if (saved) return
        const m = window.matchMedia('(prefers-color-scheme: dark)')
        const onChange = (e: MediaQueryListEvent) => setTheme(e.matches ? 'dark' : 'light')
        m.addEventListener('change', onChange)
        return () => m.removeEventListener('change', onChange)
    }, [])

    const toggleTheme = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark')
    }

    return {theme, isDark: theme === 'dark', setTheme, toggleTheme}
}
